<template>
  <div v-if="loadingList">
    <AppSkeletonTable></AppSkeletonTable>
  </div>
  <div v-else>
    <DataTable
      :value="results"
      :scrollable="$isLargeScreen.value"
      responsiveLayout="stack"
    >
      <Column header="Nome" field="name" :sortable="true"> </Column>
      <Column header="Descrição" field="description" :sortable="true">
        <template #body="{ data }">
          {{ data.description || '-' }}
        </template>
      </Column>
      <Column header="Ações" style="max-width: 100px">
        <template #body="{ data }">
          <Button
            :disabled="!hasPermissionToDelete(data)"
            type="button"
            icon="pi pi-trash"
            class="p-button-text p-button-secondary"
            @click="onShowDeleteConfirm(data.id)"
          ></Button>
        </template>
      </Column>
    </DataTable>
    <Paginator
      :rows="query.pageSize"
      :totalRecords="pagination.total"
      @page="changeListPage({ page: $event.page + 1 })"
    ></Paginator>
    <AppModalDelete
      type="Categoria"
      :visible="deleteConfirm.visible"
      :item="deleteConfirm.item"
      @confirm="onDeleteConfirm()"
      @cancel="hideDeleteConfirm()"
    ></AppModalDelete>
  </div>
</template>

<script>
import useApiList from '../../../lib/useApiList';
import useDeleteConfirm from '../../../lib/useDeleteConfirm';
import { CashFlowCategoryApi } from '../../../services/api';

export default {
  name: 'CashFlowTable',
  setup() {
    const apiList = useApiList(CashFlowCategoryApi);
    const deleteConfirm = useDeleteConfirm();
    return { ...apiList, ...deleteConfirm };
  },
  async created() {
    await this.fetchList();
  },
  methods: {
    onShowDeleteConfirm(id) {
      this.showDeleteConfirm(this.results, id, 'name');
    },
    onDeleteConfirm() {
      this.deleteListItem(this.deleteConfirm.id);
      this.hideDeleteConfirm();
    },
    hasPermissionToDelete(item) {
      return !item.default && this.$ability.can('delete', 'CashFlow');
    },
  },
};
</script>

<style>
</style>
